var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPortAutonomousGates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "m10.19 21.705 7.786-4.71.518.855-7.786 4.71zM8.16 20.07l4.73-2.996.536.844-4.73 2.997zM15.454 21.675l4.87-2.961.52.854-4.87 2.961z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M8.1 18.2c-.2 0-.3-.1-.4-.2-.1-.2-.1-.5.2-.7l.5-.3c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-.5.3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M22.1 19.4c-.2 0-.3-.1-.4-.2l-.9-1.3H8.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h12.7c.3 0 .6.2.8.4l.9 1.3c.2.2.1.5-.1.7-.1.1-.2.1-.3.1M23 22.6H2.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H23c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M23.7 22.6h-3.6v-4.2h3.6zm-2.6-1h1.6v-2.2h-1.6z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M20.3 19.4c-.1 0-.2 0-.3-.1L9 11.5c-.2-.2-.3-.5-.1-.7s.5-.3.7-.1l11 7.8c.2.2.3.5.1.7-.1.1-.3.2-.4.2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M8.4 21c-.3 0-.5-.2-.5-.4L6.2 4.3h-.6L4.1 20.6c0 .3-.3.5-.5.5-.3 0-.5-.3-.5-.5L4.7 3.3h2.5L9 20.4c-.1.3-.3.6-.6.6.1 0 0 0 0 0"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M16.4 12.2c-.3 0-.5-.2-.5-.5V6.8H8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8.9v5.8c0 .3-.2.6-.5.6"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.4 5.8H4v1h-.6z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M9.7 22.6H2.3v-2.3h7.4zm-6.4-1h5.4v-.3H3.3zM7 9.1H4.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H7c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M17.7 13c-.2 0-.4-.2-.4-.4v-.5h-1.7v.5c0 .2-.2.4-.4.4s-.4-.2-.4-.4v-1.2H18v1.2c0 .3-.1.4-.3.4"
})));
export default SvgPortAutonomousGates;